import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  Table,
  Input,
  Select,
  Popover,
  Pagination,
  DatePicker,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
const { RangePicker } = DatePicker;

export default ({
  usuario,
  history,
  certificacionesTraspasos,
  verResolucion,
  total,
  onDelete,
  pagina,
  tamPagina,
  cambiarTamañoPagina,
  cambiarPagina,
  loadingTabla,
  onChange,
  rangoFechas,
  descargarReporte,
  filtroEstadoPadre,
  setFiltrarEstado,
  filtroOrigenPadre,
  setFiltrarOrigen,
  filtroDestinoPadre,
  setFiltrarDestino,
  listaOrganismos,
  filtroNumTraspasoPadre,
  setFiltrarNumTraspaso,
}) => {
  const [filtroOrigen, setFiltroOrigen] = useState(filtroOrigenPadre);
  const [filtroDestino, setFiltroDestino] = useState(filtroDestinoPadre);
  const [filtroEstado, setFiltroEstado] = useState(filtroEstadoPadre);
  const [filtroNumTraspaso, setFiltroNumTraspaso] = useState(
    filtroNumTraspasoPadre
  );
  const [disableReporte, setDisableReporte] = useState(true);

  useEffect(() => {
    if (rangoFechas.fechaInicial !== '' && rangoFechas.fechaFinal !== '') {
      if (certificacionesTraspasos.length <= 0) {
        setDisableReporte(true);
      } else if (usuario.rol !== 'SUELDOS') {
        setDisableReporte(false);
      } else if (sonTodosProcesados) {
        setDisableReporte(false);
      } else if (
        filtroEstadoPadre === 'PROCESADO' &&
        filtroEstado === 'PROCESADO'
      ) {
        setDisableReporte(false);
      } else {
        setDisableReporte(true);
      }
    } else {
      setDisableReporte(true);
    }
  }, [rangoFechas, filtroEstadoPadre]);

  // FUNCION PARA VERIFICAR SI SON TODOS PROCESADOS
  const sonTodosProcesados = certificacionesTraspasos.every((obj, index) => {
    if (!obj.hasOwnProperty('estado')) {
      return false;
    }
    if (index === 0) {
      return true;
    }
    return obj.estado === 'PROCESADO';
  });

  const columns = [
    {
      title: 'N°',
      dataIndex: 'traspaso',
      render: (traspaso, record) => {
        if (traspaso && traspaso.numero) {
          return traspaso.numero;
        } else if (record.numeroCertPorTipo) {
          return record.numeroCertPorTipo;
        }
        return 'S/N°';
      },
      filterDropdown: (
        <div>
          <Input
            style={{ width: 120 }}
            placeholder="Buscar N°"
            value={filtroNumTraspaso}
            onChange={e => setFiltroNumTraspaso(e.target.value)}
            onPressEnter={() => setFiltrarNumTraspaso(filtroNumTraspaso)}
          />
          <Button
            icon={<Icons.SearchOutlined />}
            type="primary"
            onClick={() => setFiltrarNumTraspaso(filtroNumTraspaso)}
          />
          <Button
            icon={<Icons.CloseCircleOutlined />}
            type="danger"
            onClick={() => {
              setFiltrarNumTraspaso(null);
              setFiltroNumTraspaso(null);
            }}
          />
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroNumTraspaso ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Tipo Certificacion',
      dataIndex: 'tipoCertificacionTraspaso',
      render: tipoCert =>
        tipoCert ? tipoCert.nombre : "Traspaso"
    },
    {
      title: 'Reemplazante',
      dataIndex: 'reemplazante',
      render: usuario =>
        usuario ? usuario.apellido.toUpperCase() + ', ' + usuario.nombre.toUpperCase()    : '',
    },
    {
      title: 'Fecha Carga',
      dataIndex: 'fechaCreacion',
      with: 120,
      render: fecha => moment(fecha).format('DD-MM-YYYY'),
    },
    {
      title: 'Origen',
      dataIndex: 'origen',
      render: organismo => organismo.nombre,
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Organismo:</p>
            </Col>
            <Col span={16}>
              <Select
                style={{ width: 415, margin: '10px 5px' }}
                id="organismos"
                placeholder="Seleccione el organismo"
                onSelect={valor => setFiltroOrigen(valor)}
                value={filtroOrigen}
              >
                {listaOrganismos &&
                  listaOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() => setFiltrarOrigen(filtroOrigen)}
              />

              <Button
                icon={<Icons.EditOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => {
                  setFiltrarOrigen(null);
                  setFiltroOrigen(null);
                }}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroOrigen ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Destino',
      dataIndex: 'destino',
      render: organismo => organismo? organismo.nombre : "-",
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Organismo:</p>
            </Col>
            <Col span={16}>
              <Select
                style={{ width: 415, margin: '10px 5px' }}
                id="organismos"
                placeholder="Seleccione el organismo"
                onSelect={valor => setFiltroDestino(valor)}
                value={filtroDestino}
              >
                {listaOrganismos &&
                  listaOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() => setFiltrarDestino(filtroDestino)}
              />

              <Button
                icon={<Icons.EditOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => {
                  setFiltrarDestino(null);
                  setFiltroDestino(null);
                }}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroDestino ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Fecha Desde',
      dataIndex: 'fechaDesde',
      width: 120,
      render: fecha => moment(fecha).format('DD-MM-YYYY'),
    },
    {
      title: 'Fecha Hasta',
      dataIndex: 'fechaHasta',
      width: 120,
      render: fecha => moment(fecha).format('DD-MM-YYYY'),
    },
    {
      title: 'Normativa',
      dataIndex: 'normativa',
    },
    {
      title: 'Obs.',
      key: 'obs',
      width: 100,
      align: 'center',
      render: certificacion =>
        certificacion && certificacion.observacionCarga ? (
          <Popover
            content={
              <div>
                <div>
                  <h3>Observación de la Precarga:</h3>
                  <Row>
                    Fecha:
                    {certificacion.fechaCreacion
                      ? ' ' +
                        moment(certificacion.fechaCreacion).format('DD/MM/YYYY')
                      : ''}
                  </Row>
                  <Row>
                    Obs:
                    {certificacion.observacionCarga
                      ? ' ' + certificacion.observacionCarga
                      : ''}
                  </Row>
                </div>
                <hr />
                <div>
                  <h3>Observación del Visado DGJP:</h3>
                  <Row>
                    Fecha:
                    {certificacion.fechaVisado
                      ? ' ' +
                        moment(certificacion.fechaVisado).format('DD/MM/YYYY')
                      : ''}
                  </Row>
                  <Row>
                    Obs:
                    {certificacion.observacionVisado
                      ? ' ' + certificacion.observacionVisado
                      : ''}
                  </Row>
                </div>
                <hr />
                <div>
                  <h3>Observación de Procesado Sueldos:</h3>
                  <Row>
                    Fecha:
                    {certificacion.fechaProcesado
                      ? ' ' +
                        moment(certificacion.fechaProcesado).format(
                          'DD/MM/YYYY'
                        )
                      : ''}
                  </Row>
                  <Row>
                    Obs:
                    {certificacion.observacionProcesado
                      ? ' ' + certificacion.observacionProcesado
                      : ''}
                  </Row>
                </div>
              </div>
            }
            title={`Observaciones de la certificación`}
          >
            <Icons.SolutionOutlined
              style={{
                fontSize: '24px',
                color: '#1890ff',
              }}
            />
          </Popover>
        ) : (
          <Icons.SolutionOutlined
            style={{ fontSize: '24px', color: '#878a88' }}
          />
        ),
    },
    {
      title: 'Viaticos',
      dataIndex: 'pagoViaticos',
      render: pagoViaticos =>
        pagoViaticos ? <span>Si</span> : <span>No</span>,
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      width: 120,
      render: estado => estado.toUpperCase(),
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Estado:</p>
            </Col>
            <Col span={16}>
              <Select
                style={{ width: 180, margin: '10px 18px' }}
                id="estados"
                placeholder="Seleccione el estado"
                onSelect={valor => setFiltroEstado(valor)}
                value={filtroEstado}
              >
                {usuario.rol !== 'SUELDOS' ? (
                  <Select.Option key={'PRECARGADO'}>PRECARGADO</Select.Option>
                ) : null}
                <Select.Option key={'VISADO'}>VISADO</Select.Option>
                <Select.Option key={'PROCESADO'}>PROCESADO</Select.Option>
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '7px 5px' }}
                onClick={() => {
                  setFiltrarEstado(filtroEstado);
                }}
              />
              <Button
                icon={<Icons.EditOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => {
                  setFiltrarEstado(null);
                  setFiltroEstado(null);
                }}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroEstado ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (text, record) => (
        <span>
          {record.estado == 'PRECARGADO' &&
          (usuario.rol === 'DGJP_DIRECTOR' || usuario.rol === 'SUPERVISOR') ? (
            <Button
              size="small"
              type="primary"
              icon={<Icons.CheckOutlined />}
              style={{ marginRight: 10 }}
              onClick={() =>
                history.push(`/rrhh/certificacionTraspaso/${record._id}/visar`)
              }
            >
              VISAR
            </Button>
          ) : null}

          {record.estado == 'VISADO' &&
          (usuario.rol === 'SUELDOS' || usuario.rol === 'SUPERVISOR') ? (
            <Button
              size="small"
              type="primary"
              icon={<Icons.CheckOutlined />}
              style={{ marginRight: 10 }}
              onClick={() =>
                history.push(
                  `/rrhh/certificacionTraspaso/${record._id}/procesar`
                )
              }
            >
              PROCESAR
            </Button>
          ) : null}

          <Button
            style={{ marginRight: 10 }}
            icon={<Icons.FileSearchOutlined />}
            size="small"
            onClick={() => verResolucion(record.resolucion.archivoId)}
          >
            Resolucion
          </Button>

          {record.estado === 'PRECARGADO' &&
          (usuario.rol === 'DGJP_DIRECTOR' || usuario.rol === 'SUPERVISOR') ? (
            <Button
              size="small"
              icon={<Icons.DeleteOutlined />}
              type="danger"
              onClick={() => onDelete(record._id)}
            />
          ) : null}
        </span>
      ),
    },
  ];

  const pagination = {
    onChange: page => {
      cambiarPagina(page);
    },
    total: total,
    current: pagina,
    pageSize: tamPagina ? tamPagina : null,
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => {
      cambiarTamañoPagina(pageSize);
      cambiarPagina(1);
    },
  };

  const onDescargar = () => {
    descargarReporte();
  };

  return (
    <div>
      <Table
        rowKey="_id"
        columns={columns}
        pagination={pagination}
        dataSource={certificacionesTraspasos}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}>
              {' '}
              Certificaciones{' '}
            </h2>
            <Row style={{ marginTop: 15 }}>
              <Col offset={6}>
                <Row>
                  <Col span={6}>
                    <h4>Rango de Fechas Carga: </h4>
                  </Col>
                  <Col span={16}>
                    <RangePicker
                      style={{ width: 350, marginLeft: 5 }}
                      onChange={onChange}
                      format={'DD-MM-YYYY'}
                      defaultValue={[
                        rangoFechas.fechaInicial,
                        rangoFechas.fechaFinal,
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Button
                  style={{ marginLeft: 15 }}
                  type="primary"
                  onClick={onDescargar}
                  disabled={disableReporte}
                >
                  <Icons.DownloadOutlined />
                  Descargar Reporte
                </Button>
              </Col>
            </Row>
          </div>
        )}
        locale={{
          emptyText: 'Sin certificaciones.',
        }}
        loading={loadingTabla}
      />
    </div>
  );
};
